<h2 mat-dialog-title class="title-small">Create Pricing Profile</h2>

<mat-dialog-content class="mat-typography" style="padding-top: 10px;">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="row" fxLayoutGap="16px">
            <mat-form-field fxFlex class="custom-text-field" appearance="outline">
                <mat-label>Code</mat-label>
                <input matInput formControlName="code" maxlength="8" placeholder="e.g. CORP">
                <mat-error *ngIf="form.get('code')?.hasError('required')">Code is required</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex class="custom-text-field" appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" maxlength="60" placeholder="Profile name">
                <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
            </mat-form-field>
        </div>

        <mat-form-field class="custom-text-field" appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput rows="3" formControlName="description" maxlength="180"
                placeholder="Describe the pricing profile"></textarea>
            <mat-error *ngIf="form.get('description')?.hasError('required')">Description is required</mat-error>
        </mat-form-field>

        <mat-form-field class="custom-select-field" appearance="outline">
            <mat-label>Pricing Setup</mat-label>
            <mat-select formControlName="copyFromProfileCode">
                <mat-option value="">Manually add pricing</mat-option>
                <mat-option *ngFor="let profile of data.existingProfiles" [value]="profile.code">
                    Copy from {{ profile.code }} - {{ profile.name }}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="isManualEntry">Creates the profile with blank prices for manual entry.</mat-hint>
            <mat-hint *ngIf="!isManualEntry">Copies all stations, storage, and equipment prices from the selected profile.</mat-hint>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 16px 24px;">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="onCreate()">Create Profile</button>
</mat-dialog-actions>
